import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { appointmentBooksState, setAppointmentBooksState } from '../../../../../../store/reducers/appointments';
import AgyleToggleButtons from '../../../../../../components/ui/buttons/agyleToggleButtons';
import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { useSessionStyles } from '../useSessionStyles';
import Typography from '@mui/material/Typography';
import { APPOINTMENT_BOOK_TYPES } from '../../../../../ward/map/patientList/utils/edReviewUtils';
import _ from 'lodash';
import { Stack } from '@mui/material';

const AppointmentTypeInfo = ({ activities }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const classes = useSessionStyles();

    // Selector
    const bookState = useSelector(appointmentBooksState);

    useEffect(() => {
        if (!_.isNull(activities) && (activities?.length === 0 || activities.every((a) => a?.admission?.endDate))) {
            dispatch(
                setAppointmentBooksState({
                    type: APPOINTMENT_BOOK_TYPES.NONE,
                }),
            );
        }
    }, [activities]);

    const onChange = (val) => {
        dispatch(
            setAppointmentBooksState({
                type: val,
            }),
        );
    };

    return (
        <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={1}>
            <Typography variant="body2">{t('Appointment type')}:</Typography>

            <AgyleToggleButtons
                disabled={!bookState.linkedAttendance}
                value={bookState?.type}
                classNameRoot={classes.toggleRoot}
                classNameLabel={classes.toggleLabel}
                classNameSelected={classes.toggleSelected}
                onChange={onChange}
                options={[
                    { value: APPOINTMENT_BOOK_TYPES.NONE, label: t('Appointment') },
                    { value: APPOINTMENT_BOOK_TYPES.BEDAS, label: t('BEDAS') },
                    { value: APPOINTMENT_BOOK_TYPES.SDEC, label: t('SDEC') },
                    { value: APPOINTMENT_BOOK_TYPES.UTC, label: t('UTC') },
                ]}
            />
        </Stack>
    );
};

export default AppointmentTypeInfo;
